// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, IconButton, CircularProgress,
//   Grid, Card, CardMedia, CardActions, TextField
// } from '@mui/material';
// import { Add, Edit, Delete } from '@mui/icons-material';
// import axios from 'axios';
// import apiUrl from '../../Config';

// const NewRelease = () => {
//   const [books, setBooks] = useState([]);
//   const [showForm, setShowForm] = useState(false);
//   const [editingBook, setEditingBook] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // Fetch books
//   const fetchBooks = async () => {
//     try {
//       const res = await axios.get(`${apiUrl}/upcomingbooks/getallupcommingbook`);
//       setBooks(res.data.allBooks || []);
//     } catch (err) {
//       console.error('Error fetching upcoming books:', err);
//     }
//   };

//   useEffect(() => {
//     fetchBooks();
//   }, []);

//   // Handle image selection
//   const handleImageChange = (e) => {
//     setSelectedImage(e.target.files[0]);
//   };

//   // Open form for create or edit
//   const handleOpenForm = (book = null) => {
//     setEditingBook(book);
//     setSelectedImage(null);
//     setShowForm(true);
//   };

//   // Cancel form
//   const handleCancel = () => {
//     setShowForm(false);
//     setEditingBook(null);
//     setSelectedImage(null);
//   };

//   // Submit form
//   const handleSubmit = async () => {
//     if (!selectedImage && !editingBook) {
//       alert('Please select an image');
//       return;
//     }

//     const formData = new FormData();
//     if (selectedImage) {
//       formData.append('upcomingImg', selectedImage);
//     }

//     try {
//       setLoading(true);
//       if (editingBook) {
//         await axios.put(`${apiUrl}/upcomingbooks/updateupcommingbook/${editingBook.id}`, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       } else {
//         await axios.post(`${apiUrl}/upcomingbooks/createupcommingbook`, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       }
//       handleCancel();
//       fetchBooks();
//     } catch (err) {
//       console.error('Submit error:', err);
//       alert('Failed to upload image');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete a book
//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`${apiUrl}/upcomingbooks/deleteupcommingbook/${id}`);
//       fetchBooks();
//     } catch (err) {
//       console.error('Delete failed:', err);
//       alert('Failed to delete');
//     }
//   };

//   return (
//     <Box p={3}>
//       {!showForm && (
//   <>
//     <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//       <Typography variant="h5">Upcoming Book Releases</Typography>
//       <Button variant="contained" startIcon={<Add />} onClick={() => handleOpenForm()}>
//         Add New
//       </Button>
//     </Box>

//     <Grid container spacing={2}>
//       {books?.map((book) => (
//         <Grid size={{xs:12, sm:6, md:3}} key={book.id}>
//           <Card>
//             <CardMedia
//               component="img"
//               height="200"
//               image={book.imageUrl}
//               alt="Upcoming Book"
//             />
//             <CardActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
//               <Button variant="outlined" onClick={() => handleOpenForm(book)}>Edit</Button>
//               <Button variant="contained" onClick={() => handleDelete(book.id)}>Delete</Button>
//             </CardActions>
//           </Card>
//         </Grid>
//       ))}
//       {books.length === 0 && (
//         <Typography mt={2} color="textSecondary">No upcoming books found.</Typography>
//       )}
//     </Grid>
//   </>
// )}


//       {/* Book Cards */}
//       {/* <Grid container spacing={2}>
//         {books?.map((book) => (
//           <Grid size={{xs:12, sm:6, md:3}} key={book.id}>
//             <Card>
//               <CardMedia
//                 component="img"
//                 height="200"
//                 image={book.imageUrl}
//                 alt="Upcoming Book"
//               />
//               <CardActions sx={{display:'flex', justifyContent:'space-between'}}>
//                 <Button variant='outlined' onClick={() => handleOpenForm(book)}>Edit</Button>
//                 <Button variant='contained' onClick={() => handleDelete(book.id)}>Delete </Button>
//               </CardActions>
//             </Card>
//           </Grid>
//         ))}
//         {books.length === 0 && (
//           <Typography mt={2} color="textSecondary">No upcoming books found.</Typography>
//         )}
//       </Grid> */}

//       {/* Create/Edit Form Section */}
//       {showForm && (
//         <Box
//           mt={3}
//           p={3}
//           border="1px solid #ccc"
//           borderRadius={2}
//           bgcolor="#f9f9f9"
//           maxWidth={500}
//           // mx="auto"
//         >
//           <Typography variant="h6" mb={2}>
//             {editingBook ? 'Edit' : 'Add New'} Upcoming Book
//           </Typography>

//           <Button variant="outlined" component="label" fullWidth>
//             {selectedImage ? selectedImage.name : 'Upload Image'}
//             <input type="file" hidden accept="image/*" onChange={handleImageChange} />
//           </Button>

//           {/* Show existing image if editing and no new image selected */}
//           {editingBook && !selectedImage && (
//             <Box mt={2}>
//               <Typography variant="subtitle2">Current Image:</Typography>
//               <img
//                 src={editingBook.imageUrl}
//                 alt="Current Book"
//                 style={{ width: '100%', maxHeight: 200, objectFit: 'contain', marginTop: 8 }}
//               />
//             </Box>
//           )}

//           <Box display="flex" gap={2} mt={3}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleSubmit}
//               disabled={loading}
//               fullWidth
//             >
//               {loading ? <CircularProgress size={20} /> : editingBook ? 'Update' : 'Create'}
//             </Button>
//             <Button variant="outlined" color="secondary" onClick={handleCancel} fullWidth>
//               Cancel
//             </Button>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default NewRelease;

import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, CircularProgress,
  Grid, Card, CardMedia, CardActions,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { Add } from '@mui/icons-material';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiUrl from '../../Config';

const NewRelease = () => {
  const [books, setBooks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingBook, setEditingBook] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchBooks = async () => {
    try {
      const res = await axios.get(`${apiUrl}/upcomingbooks/getallupcommingbook`);
      setBooks(res.data.allBooks || []);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch upcoming books');
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const handleImageChange = (e) => {
    setSelectedImage(e.target.files[0]);
  };

  const handleOpenForm = (book = null) => {
    setEditingBook(book);
    setSelectedImage(null);
    setIsActive(book ? book.isActive : true);
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingBook(null);
    setSelectedImage(null);
    setIsActive(true);
  };

  const handleSubmit = async () => {
    if (!selectedImage && !editingBook) {
      toast.error('Please select an image');
      return;
    }

    const formData = new FormData();
    if (selectedImage) {
      formData.append('upcomingImg', selectedImage);
    }
    formData.append('isActive', isActive);

    try {
      setLoading(true);
      if (editingBook) {
        await axios.put(
          `${apiUrl}/upcomingbooks/updateupcommingbook/${editingBook.id}`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        toast.success('Upcoming book updated successfully!');
      } else {
        await axios.post(
          `${apiUrl}/upcomingbooks/createupcommingbook`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        toast.success('Upcoming book created successfully!');
      }
      handleCancel();
      fetchBooks();
    } catch (err) {
      console.error(err);
      toast.error('Failed to save upcoming book');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`${apiUrl}/upcomingbooks/deleteupcommingbook/${id}`);
      toast.success('Upcoming book deleted');
      fetchBooks();
    } catch (err) {
      console.error(err);
      toast.error('Failed to delete');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      {!showForm && (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Typography variant="h5">Upcoming Book Releases</Typography>
            <Button variant="contained" startIcon={<Add />} onClick={() => handleOpenForm()}>
              Add New
            </Button>
          </Box>

          <Grid container spacing={2}>
            {books.map((book) => (
              <Grid item xs={12} sm={6} md={3} key={book.id}>
                <Card>
                  <CardMedia
                    component="img"
                    height="200"
                    image={book.imageUrl}
                    alt="Upcoming Book"
                  />
                  <CardActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={() => handleOpenForm(book)}>
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleDelete(book.id)}
                      disabled={loading}
                    >
                      Delete
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
            {books.length === 0 && (
              <Typography mt={2} color="textSecondary">
                No upcoming books found.
              </Typography>
            )}
          </Grid>
        </>
      )}

      {showForm && (
        <Box mt={3} p={3} border="1px solid #ccc" borderRadius={2} bgcolor="#f9f9f9" maxWidth={500}>
          <Typography variant="h6" mb={2}>
            {editingBook ? 'Edit' : 'Add New'} Upcoming Book
          </Typography>

          <Button variant="outlined" component="label" fullWidth>
            {selectedImage ? selectedImage.name : 'Upload Image'}
            <input type="file" hidden accept="image/*" onChange={handleImageChange} />
          </Button>

          {editingBook && !selectedImage && (
            <Box mt={2}>
              <Typography variant="subtitle2">Current Image:</Typography>
              <img
                src={editingBook.imageUrl}
                alt="Current Book"
                style={{ width: '100%', maxHeight: 200, objectFit: 'contain', marginTop: 8 }}
              />
            </Box>
          )}

          <Box mt={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  sx={{
                    color: 'red',
                    '&.Mui-checked': {
                      color: 'red',
                    },
                  }}
                />
              }
              label="Is Active"
            />
          </Box>

          <Box display="flex" gap={2} mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={loading}
              fullWidth
            >
              {loading ? <CircularProgress size={20} /> : editingBook ? 'Update' : 'Create'}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleCancel} fullWidth>
              Cancel
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default NewRelease;
